module.exports = __webpack_public_path__ + "static/assets/4dc96f8fb171470fa04e70950268faf1.png";